export default "__VITE_ASSET__CFXabI0N__"